module.exports = __webpack_public_path__ + "img/pr-7.cb9f807d.png";